var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2077)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 4,
    width: 64,
    height: 64,
    rx: 12,
    fill: "#0AE0DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8127 30.7498C47.9319 30.8688 48.0264 31.0101 48.0909 31.1656C48.1553 31.3211 48.1885 31.4879 48.1885 31.6562C48.1885 31.8246 48.1553 31.9914 48.0909 32.1469C48.0264 32.3024 47.9319 32.4437 47.8127 32.5627L38.844 41.5315C38.725 41.6506 38.5837 41.7451 38.4281 41.8096C38.2726 41.8741 38.1059 41.9073 37.9375 41.9073C37.7691 41.9073 37.6024 41.8741 37.4469 41.8096C37.2913 41.7451 37.15 41.6506 37.031 41.5315L33.1873 37.6877C32.9469 37.4473 32.8118 37.1212 32.8118 36.7812C32.8118 36.4413 32.9469 36.1152 33.1873 35.8748C33.4277 35.6343 33.7538 35.4993 34.0938 35.4993C34.4338 35.4993 34.7598 35.6343 35.0002 35.8748L37.9375 38.8136L45.9998 30.7498C46.1188 30.6306 46.2601 30.5361 46.4156 30.4717C46.5712 30.4072 46.7379 30.374 46.9063 30.374C47.0746 30.374 47.2414 30.4072 47.3969 30.4717C47.5524 30.5361 47.6937 30.6306 47.8127 30.7498ZM57.1563 35.5C57.1563 38.7943 56.1794 42.0146 54.3492 44.7537C52.519 47.4928 49.9176 49.6277 46.8741 50.8884C43.8305 52.149 40.4815 52.4789 37.2505 51.8362C34.0195 51.1935 31.0517 49.6072 28.7223 47.2777C26.3928 44.9483 24.8065 41.9805 24.1638 38.7495C23.5211 35.5185 23.851 32.1695 25.1116 29.1259C26.3723 26.0824 28.5072 23.481 31.2463 21.6508C33.9854 19.8206 37.2057 18.8438 40.5 18.8438C44.9161 18.8484 49.15 20.6048 52.2726 23.7274C55.3952 26.85 57.1516 31.0839 57.1563 35.5ZM54.5938 35.5C54.5938 32.7125 53.7672 29.9876 52.2185 27.6699C50.6699 25.3522 48.4687 23.5458 45.8935 22.4791C43.3182 21.4124 40.4844 21.1332 37.7505 21.6771C35.0165 22.2209 32.5053 23.5632 30.5342 25.5342C28.5632 27.5053 27.2209 30.0165 26.6771 32.7504C26.1333 35.4844 26.4124 38.3181 27.4791 40.8934C28.5458 43.4687 30.3522 45.6699 32.6699 47.2185C34.9876 48.7672 37.7125 49.5938 40.5 49.5938C44.2366 49.5895 47.8189 48.1033 50.4611 45.4611C53.1033 42.8189 54.5895 39.2366 54.5938 35.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2077",
    x: 0.5,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2077",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.95f207bddaac69a8580c1954bed895a8.svg";
export { ForwardRef as ReactComponent };